import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import { httpOk, POST } from 'helpers/api'
import { formatMoney } from 'helpers/helpers'

// Корректировка долга контрагента без денег: меняется только своя сторона,
// связанному логину ничего не уходит. counterparty — 'supplier' | 'organization'
function DebtCorrectionModal({ show, onHide, onSuccess, counterparty, item, posId }) {
	const { t } = useTranslation()

	const [targetBalance, setTargetBalance] = useState('')
	const [note, setNote] = useState('')

	const current = Number(item?.balance || 0)
	const target = targetBalance === '' || targetBalance === '-' ? null : Number(String(targetBalance).replace(/\s/g, '').replace(',', '.'))
	const diff = target === null || Number.isNaN(target) ? null : target - current

	useEffect(() => {
		if (show) {
			setTargetBalance('')
			setNote('')
		}
	}, [show])

	async function submit(e) {
		e.preventDefault()
		const response = await POST('/debt-correction', {
			counterparty: counterparty,
			counterparty_id: counterparty === 'supplier' ? item.supplier_id : item.organization_id,
			pos_id: posId,
			target_balance: target,
			note: note,
		}, { loader: true })
		if (httpOk(response)) {
			onHide()
			onSuccess && onSuccess()
		}
	}

	return (
		<Modal show={show} animation={false} centered dialogClassName="update-modal-width" onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>{t('debt_correction')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={submit} autoComplete="off">
					<div className="form-group">
						<label>{t('current_debt')}</label>
						<div className={current >= 0 ? 'text-primary' : 'text-danger'}>
							<b>{formatMoney(current)}</b>
						</div>
					</div>
					<div className="form-group">
						<label>{t('new_debt')}<span className="required-mark">*</span></label>
						<input type="text" className="form-control" autoFocus
							value={targetBalance}
							onChange={(e) => setTargetBalance(e.target.value.replace(/[^\d\s.,-]/g, ''))} />
						{diff !== null &&
							<small className="text-muted">{t('difference')}: {diff > 0 ? '+' : ''}{formatMoney(diff)}</small>
						}
					</div>
					<div className="form-group">
						<label>{t('reason')}<span className="required-mark">*</span></label>
						<textarea className="form-control" rows="3"
							value={note}
							onChange={(e) => setNote(e.target.value)} />
					</div>
					<p className="text-muted small">{t('debt_correction_hint')}</p>
					<div className="d-flex w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={onHide} tabIndex="-1">
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100"
							disabled={diff === null || Math.abs(diff) < 0.01 || note.trim().length < 3}>
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default DebtCorrectionModal
